const NOTIFICATION_CREATED = "NOTIFICATION_CREATED";
const NOTIFICATION_DELETE = "NOTIFICATION__DELETE";
const NOTIFICATION_READ = "NOTIFICATION_READ";
const NOTIFICATION_GET = "NOTIFICATION_GET";

export {
  NOTIFICATION_CREATED,
  NOTIFICATION_DELETE,
  NOTIFICATION_READ,
  NOTIFICATION_GET,
};
